import { TextField } from "@mui/material";

const FieldText = ({ onChange, field, index }) => {
  return (
    <TextField
      name="description"
      label={field.title}
      fullWidth
      value={field.value || ""}
      onChange={(e) => onChange(e.target.value, field, index)}
    />
  );
};

export default FieldText;
